//List all Jobs as "Single Job"
import {useEffect, useState} from "react";
import fetch from "node-fetch";
import { API_ENDPOINTS } from "../../config";
import SingleJobListView from "./JobListPageSubcomponents/SingleJobListView";
import {Link, useNavigate} from "react-router-dom";
import { BoltIcon } from '@heroicons/react/20/solid';
import Button1 from "../../UI/Button1";


//create a list of all retrieved jobs
const JobListNewJobsView = () => {

    const [allJobs, setAllJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showJobs, setShowJobs] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [jobsPerPage] = useState(10);
    const [jobsLanguage, setJobsLanguage] = useState('en');


    async function FetchAllJobs() {
        const token = localStorage.getItem('token');
        setLoading(true);
        console.log("Get All new  Jobs");

        try {
            const response = await fetch(API_ENDPOINTS.getAllNewJobs + '/'+  jobsLanguage,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }
            const data = await response.json();
            console.log("All New jobs fetched:", data);
            setAllJobs(data.items);
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch jobs:', error);
            setLoading(false);
        }
    }

//Anytime a site is refreshed, all jobs should be retrieved
    useEffect(() => {
        FetchAllJobs();
    }, [jobsLanguage]);


    const navigate = useNavigate();

    const handleDelete =  async (id) => {
        const token = localStorage.getItem('token');

        setLoading(true);
        const url = `${API_ENDPOINTS.deleteSingleNewJob}/${id}/${jobsLanguage}`;
        console.log("HandleDelete with url => " , url)
        const response = await fetch(url, {
            method:'DELETE',
            headers : {
                'Content-Type' : 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if(response.ok){
            console.log('Delete OK , response => ', response);
            await FetchAllJobs();
        }

        setLoading(false);
    }


    const indexOfLastJob = currentPage * jobsPerPage;
    const indexOfFirstJob = indexOfLastJob - jobsPerPage;
    const currentJob =  indexOfFirstJob && indexOfLastJob && allJobs.slice(indexOfFirstJob, indexOfLastJob);


    const paginate = (pageNumber) => setCurrentPage(pageNumber);



    return (
        <div className="p-4">
            <button
                onClick={() => setShowJobs(!showJobs)}
                className="mb-4 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300"
            >
                {showJobs ? "Hide Jobs" : "Show Jobs"}
            </button>
            <div className={'flex flex-row mt-1 mb-1 gap-1'}>
                <Button1 onclick={() => {
                    setJobsLanguage('de');
                    console.log("Language setting to DE");
                }} text={"DE"}>DE</Button1>
                <Button1 onclick={() => setJobsLanguage('en')}  text={"EN"}>EN</Button1>
            </div>
            {loading ? (
                <div className="flex justify-center items-center">
                    <BoltIcon className="animate-spin h-8 w-8 text-green-500"/>
                </div>
            ) : (
                <div
                    className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ${showJobs ? '' : 'hidden'}`}>
                    {allJobs && allJobs.map(job => (
                        <SingleJobListView
                            key={job.id}
                            handleDelete={handleDelete}
                            jobData={job}
                            id={job.id}
                            job={job}
                            lang={jobsLanguage}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}
export default JobListNewJobsView;